import React, { useState, useEffect } from 'react';
import { Star, ArrowLeft, ArrowRight } from 'lucide-react';
import { testimonials, transformBg } from '../mock';

const Testimonials = () => {
  const [idx, setIdx] = useState(2);
  const t = testimonials[idx];

  useEffect(() => {
    const id = setInterval(() => setIdx((p) => (p + 1) % testimonials.length), 7000);
    return () => clearInterval(id);
  }, []);

  const prev = () => setIdx((p) => (p - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((p) => (p + 1) % testimonials.length);

  return (
    <section className="section" style={{ backgroundColor: 'var(--bg-2)' }}>
      <div className="section-bg" style={{ backgroundImage: `url(${transformBg})`, opacity: 0.04 }} />
      <div className="section-inner">
        <div className="section-head">
          <div className="section-label">Müşteri Yorumları</div>
          <h2 className="section-title">
            Onlar Anlattı, <br />
            <span className="accent">Biz Çalıştık</span>
          </h2>
        </div>
        <div className="testimonial-card">
          <div className="testimonial-quote-icon">“</div>
          <div className="testimonial-stars">
            {Array.from({ length: t.rating }).map((_, i) => (
              <Star key={i} size={18} fill="currentColor" />
            ))}
          </div>
          <p className="testimonial-text">“{t.quote}”</p>
          <div className="testimonial-author">
            <div className="testimonial-avatar">{t.name.charAt(0)}</div>
            <div className="testimonial-name">{t.name}</div>
            <div className="testimonial-car">{t.car}</div>
          </div>
        </div>
        <div className="testimonial-nav">
          <button className="t-nav-btn" onClick={prev} aria-label="Önceki"><ArrowLeft size={16} /></button>
          <div className="t-dots">
            {testimonials.map((_, i) => (
              <button key={i} className={`t-dot ${i === idx ? 'active' : ''}`} onClick={() => setIdx(i)} />
            ))}
          </div>
          <button className="t-nav-btn" onClick={next} aria-label="Sonraki"><ArrowRight size={16} /></button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
